import { BuyersCertificate } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { t } from '@translations';
import { longDate } from '@utils/date.utils';

export const getCertificateItems = (certificate: BuyersCertificate, isBeremaUser?: boolean) => [
  { fieldName: 'product', fieldValue: certificate?.productType },
  ...(isBeremaUser ? [{ fieldName: 'customerNo', fieldValue: certificate?.dealerCustomerNo }] : []),
  { fieldName: 'model', fieldValue: certificate?.productModel },
  { fieldName: 'postCode', fieldValue: certificate?.customerPostCode },
  { fieldName: 'city', fieldValue: certificate?.customerCity },
  { fieldName: 'salesDate', fieldValue: longDate(certificate?.salesDate) },
  { fieldName: 'registrationDate', fieldValue: longDate(certificate?.registrationDate) },
  { fieldName: 'isSerialNumberValid', fieldValue: translateIsValidNumber(certificate?.isSerialNumberValid) },
];

export const buyersCertificateColumns = (isBeremaUser?: boolean) => [
  { key: 'product', name: t(TextCodes.BuyersCertificate.Block.Product) },
  ...(isBeremaUser
    ? [{ key: 'customerNo', name: t(TextCodes.BuyersCertificate.Block.CustomerNo) }]
    : []),
  { key: 'model', name: t(TextCodes.BuyersCertificate.Block.Model) },
  { key: 'postCode', name: t(TextCodes.BuyersCertificate.Block.PostCode) },
  { key: 'city', name: t(TextCodes.BuyersCertificate.Block.City) },
  { key: 'salesDate', name: t(TextCodes.BuyersCertificate.Block.SalesDate) },
  { key: 'registrationDate', name: t(TextCodes.BuyersCertificate.Block.RegistrationDate) },
  ...(isBeremaUser
    ? [{ key: 'isSerialNumberValid', name: t(TextCodes.BuyersCertificate.Block.IsSerialNumberValid) }]
    : []),
];
function translateIsValidNumber(isSerialNumberValid: boolean | undefined): string {
  if (isSerialNumberValid == null){
    return '';
  } else if (isSerialNumberValid){
    return t(TextCodes.BuyersCertificate.Block.Valid);
  }
  return t(TextCodes.BuyersCertificate.Block.NotValid);
}

